import React from 'react';

// Editorial empty/error state (design-recreation): optional gold-ringed
// glyph, light serif caps headline, italic subtitle, gold-bordered pill CTA
// — the same vocabulary as the rest of the rebuilt surfaces (segmented
// pills, NEW GLOWUP button) instead of the old censor-bar CTA.
//
// Props:
//   headline          caps serif headline
//   subtitle          supporting line (rendered italic)
//   ctaLabel          optional CTA text
//   onCta             CTA handler
//   secondaryCtaLabel optional second action (renders both CTAs in a row)
//   onSecondaryCta    second action handler
//   note              optional italic status line under the CTAs
//   icon              optional rendered glyph, shown in a gold-ringed circle
const CTA_CLASS = [
  'flex items-center gap-2.5 bg-transparent border border-[rgba(201,164,92,0.5)] rounded-full',
  'px-6 py-3 cursor-pointer font-display uppercase text-xs tracking-[0.2em] text-aurum-bright',
  'transition-all duration-200 ease-mogged hover:border-aurum-bright hover:shadow-aurum-glow',
].join(' ');

const SECONDARY_CTA_CLASS = [
  'flex items-center gap-2.5 bg-transparent border border-[rgba(255,255,255,0.22)] rounded-full',
  'px-6 py-3 cursor-pointer font-display uppercase text-xs tracking-[0.2em] text-bone-dim',
  'transition-all duration-200 ease-mogged hover:border-[rgba(255,255,255,0.5)] hover:text-bone',
].join(' ');

const EmptyState = ({
  headline,
  subtitle,
  ctaLabel,
  onCta,
  secondaryCtaLabel,
  onSecondaryCta,
  note,
  icon,
  className = '',
}) => (
  <div
    className={`flex flex-col items-center text-center gap-6 py-12 ${className}`.trim()}
  >
    {icon && (
      <div
        className="w-[54px] h-[54px] rounded-full border border-[rgba(201,164,92,0.4)] flex items-center justify-center text-aurum"
        aria-hidden="true"
      >
        {icon}
      </div>
    )}
    <div>
      <h2 className="font-display font-light uppercase text-bone tracking-[0.08em] leading-tight m-0 text-[26px] lg:text-[34px]">
        {headline}
      </h2>
      {subtitle && (
        <p className="font-display italic text-bone-dim text-[15px] leading-relaxed mt-3 mb-0 max-w-[440px]">
          {subtitle}
        </p>
      )}
    </div>
    {ctaLabel && !secondaryCtaLabel && (
      <button type="button" onClick={onCta} className={CTA_CLASS}>
        {ctaLabel}
      </button>
    )}
    {secondaryCtaLabel && (
      <div className="flex flex-col sm:flex-row items-center gap-3">
        {ctaLabel && (
          <button type="button" onClick={onCta} className={CTA_CLASS}>
            {ctaLabel}
          </button>
        )}
        <button type="button" onClick={onSecondaryCta} className={SECONDARY_CTA_CLASS}>
          {secondaryCtaLabel}
        </button>
      </div>
    )}
    {note && (
      <p className="font-display italic text-bone-dim text-[13px] tracking-[0.12em] m-0" role="status">
        {note}
      </p>
    )}
  </div>
);

export default EmptyState;
